import { EditorStarterItem } from '../items/item-type';
import { TrackType } from '../state/types';
import {resolveGroupGeometry} from '../items/group/group-geometry';

type ItemsInput = EditorStarterItem[] | Record<string, EditorStarterItem>;

/**
 * tracks 에 배치된 아이템들만 기준으로 전체 컴포지션 길이를 계산한다.
 * 트랙 정보가 없으면 items 전체를 대상으로 계산한다.
 */
const collectTrackItems = (
  itemsMap: Record<string, EditorStarterItem>,
  tracks?: TrackType[],
) => {
  if (!tracks || tracks.length === 0) {
    return Object.values(itemsMap);
  }

  const collected: EditorStarterItem[] = [];
  const seen = new Set<string>();

  for (const track of tracks) {
    for (const itemId of track.items) {
      if (seen.has(itemId)) {
        continue;
      }

      const item = itemsMap[itemId];
      if (!item) {
        continue;
      }

      collected.push(item);
      seen.add(itemId);
    }
  }

  return collected;
};

/**
 * 전체 타임라인 끝 프레임을 반환한다.
 * - tracks가 주어지면 해당 트랙에서 실제 사용중인 아이템만 고려한다.
 * - tracks가 없으면 전달된 items 전체를 사용한다.
 */
export const getCompositionDuration = (
  items: ItemsInput,
  tracks?: TrackType[],
) => {
  const itemsMap = Array.isArray(items)
    ? items.reduce<Record<string, EditorStarterItem>>((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {})
    : items;

  const itemsToMeasure = collectTrackItems(itemsMap, tracks);

  if (itemsToMeasure.length === 0) {
    return 0;
  }

  return itemsToMeasure.reduce((maxDuration, item) => {
    const geometry=item.type==='group'?resolveGroupGeometry(item,itemsMap):item;
    const itemEnd = geometry.from + geometry.durationInFrames;
    return itemEnd > maxDuration ? itemEnd : maxDuration;
  }, 0);
};
